module.exports = __webpack_public_path__ + "static/img/main_mypage_icon_b.29398392.svg";